export default class Utils {

    static isDevelopment(): boolean {
        return process.env.NODE_ENV === 'development';
    }
}